// File: /opt/dev_environment/assets/workspace/app-init/src/constants/leitner.js

/**
 * Leitner system configuration
 * Compartment review intervals in days
 */
export const LEITNER_COMPARTMENTS = {
  1: { label: 'Fach 1', interval: 1, color: 'var(--color-fach-1)', description: 'Täglich' },
  2: { label: 'Fach 2', interval: 2, color: 'var(--color-fach-2)', description: 'Alle 2 Tage' },
  3: { label: 'Fach 3', interval: 7, color: 'var(--color-fach-3)', description: 'Wöchentlich' },
  4: { label: 'Fach 4', interval: 14, color: 'var(--color-fach-4)', description: 'Alle 2 Wochen' },
  5: { label: 'Fach 5', interval: 30, color: 'var(--color-fach-5)', description: 'Monatlich' },
};

export const TOTAL_COMPARTMENTS = 5;

export const QUERY_DIRECTIONS = {
  IT_DE: 'IT→DE',
  DE_IT: 'DE→IT',
  MIXED: 'Gemischt',
};

export const WORD_CATEGORIES = [
  { value: 'noun', label: 'Substantiv' },
  { value: 'verb', label: 'Verb' },
  { value: 'adjective', label: 'Adjektiv' },
  { value: 'adverb', label: 'Adverb' },
  { value: 'preposition', label: 'Präposition' },
  { value: 'conjunction', label: 'Konjunktion' },
  { value: 'phrase', label: 'Redewendung' },
  { value: 'other', label: 'Sonstiges' },
];

export const GRAMMATICAL_GENDERS = [
  { value: 'm', label: 'maskulin (il/lo)', abbreviation: 'm' },
  { value: 'f', label: 'feminin (la)', abbreviation: 'f' },
  { value: 'n', label: 'neutral', abbreviation: 'n' },
];

export const TRAINING_MODES = {
  VOKABELN: 'vokabeln',
  VERBEN: 'verben',
};

export const NAV_ITEMS = [
  { path: '/', label: 'Start', icon: 'home' },
  { path: '/vokabeln', label: 'Vokabeln', icon: 'cards' },
  { path: '/verben', label: 'Verben', icon: 'verb' },
  { path: '/statistik', label: 'Statistik', icon: 'stats' },
];